/**
 * The zone every document time is printed in (ZLAYT-1414, QA D-18).
 *
 * The backend prints the "Generated:" header and document names in
 * settings.DOCUMENT_TIME_ZONE (env DOCUMENT_TIME_ZONE, default
 * "America/Chicago", the firm's zone); the version selectors print in this
 * one. Both default to America/Chicago (ZLAYT-1451: this side used to fall
 * back to UTC, so with neither env var set the selector and the header
 * disagreed by five hours). A deploy that wants another zone sets
 * DOCUMENT_TIME_ZONE on the backend and VITE_DOCUMENT_TIME_ZONE here to the
 * same IANA name. The browser zone is
 * deliberately never used: two readers in two zones would otherwise see two
 * calendar days for one version, each with a confident zone label.
 */
const FALLBACK_ZONE = 'America/Chicago';

const isKnownZone = (zone: string): boolean => {
  try {
    return (
      Intl.DateTimeFormat('en-US', { timeZone: zone }).resolvedOptions()
        .timeZone.length > 0
    );
  } catch {
    return false;
  }
};

const resolveDocumentTimeZone = (): string => {
  const configured = (import.meta.env?.VITE_DOCUMENT_TIME_ZONE || '').trim();
  if (!configured) return FALLBACK_ZONE;
  if (isKnownZone(configured)) return configured;
  console.error(
    `VITE_DOCUMENT_TIME_ZONE "${configured}" is not a known IANA zone; using ${FALLBACK_ZONE}`
  );
  return FALLBACK_ZONE;
};

export const DOCUMENT_TIME_ZONE: string = resolveDocumentTimeZone();
